/* GET TEMPLATES */
export const GET_ADMIN_NOTIFICATION_TEMPLATES = "GET_ADMIN_NOTIFICATION_TEMPLATES"
export const GET_ADMIN_NOTIFICATION_TEMPLATES_SUCCESS = "GET_ADMIN_NOTIFICATION_TEMPLATES_SUCCESS"
export const GET_ADMIN_NOTIFICATION_TEMPLATES_ERROR = "GET_ADMIN_NOTIFICATION_TEMPLATES_ERROR"

/* CREATE TEMPLATES */
export const CREATE_ADMIN_NOTIFICATION_TEMPLATE = "CREATE_ADMIN_NOTIFICATION_TEMPLATE"
export const CREATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS = "CREATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS"
export const CREATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR = "CREATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR"

/* UPDATE TEMPLATES */
export const UPDATE_ADMIN_NOTIFICATION_TEMPLATE = "UPDATE_ADMIN_NOTIFICATION_TEMPLATE"
export const UPDATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS = "UPDATE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS"
export const UPDATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR = "UPDATE_ADMIN_NOTIFICATION_TEMPLATE_ERROR"

/* DELETE TEMPLATES */
export const DELETE_ADMIN_NOTIFICATION_TEMPLATE = "DELETE_ADMIN_NOTIFICATION_TEMPLATE"
export const DELETE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS = "DELETE_ADMIN_NOTIFICATION_TEMPLATE_SUCCESS"
export const DELETE_ADMIN_NOTIFICATION_TEMPLATE_ERROR = "DELETE_ADMIN_NOTIFICATION_TEMPLATE_ERROR"

/* GET USER NOTIFICATIONS */
export const GET_ADMIN_USER_NOTIFICATION_PREFERENCES = "GET_ADMIN_USER_NOTIFICATION_PREFERENCES"
export const GET_ADMIN_USER_NOTIFICATION_PREFERENCES_SUCCESS = "GET_ADMIN_USER_NOTIFICATION_PREFERENCES_SUCCESS"
export const GET_ADMIN_USER_NOTIFICATION_PREFERENCES_ERROR = "GET_ADMIN_USER_NOTIFICATION_PREFERENCES_ERROR"

/* UPDATE USER NOTIFICATIONS */
export const UPDATE_ADMIN_USER_NOTIFICATIONS = "UPDATE_ADMIN_USER_NOTIFICATIONS"
export const UPDATE_ADMIN_USER_NOTIFICATIONS_SUCCESS = "UPDATE_ADMIN_USER_NOTIFICATIONS_SUCCESS"
export const UPDATE_ADMIN_USER_NOTIFICATIONS_ERROR = "UPDATE_ADMIN_USER_NOTIFICATIONS_ERROR"